import styled from 'styled-components';

export const StyledPrivacyWrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #0c0c0c 0%, #1a1a1a 100%);
  color: #dfe6e9;
  padding: 40px 20px; /* add vertical padding to breathe */
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledPrivacyContent = styled.div`
  max-width: 1000px;
  width: 100%;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  padding: 3rem;
  margin-bottom: 3rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  line-height: 1.8;
  
  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
    margin: 0 10px 2rem 10px;
  }

  /* Privacy policy content styling */
  h1, h2, h3, h4, h5, h6 {
    color: #fdcb6e !important;
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
    font-weight: 600;
  }

  h1 {
    font-size: 2.5rem !important;
    text-align: center;
    margin-top: 0;
    color: #fdcb6e !important;
    
    @media (max-width: 768px) {
      font-size: 2rem !important;
    }
  }

  h2 {
    font-size: 1.8rem !important;
    border-bottom: 2px solid #fdcb6e;
    padding-bottom: 0.5rem;
    color: #fdcb6e !important;
    
    @media (max-width: 768px) {
      font-size: 1.5rem !important;
    }
  }

  h3 {
    font-size: 1.4rem !important;
    color: #74b9ff !important;
  }

  p, div, span {
    margin-top: 0;
    margin-bottom: 0.75rem;
    text-align: left;
    color: #f8f9fa !important;
    line-height: 1.65; /* slightly taller for readability */
  }

  ul, ol {
    margin: 1rem 0; /* increase vertical rhythm */
    padding-left: 1.5rem;
  }

  li {
    margin-bottom: 0.4rem;
    color: #f8f9fa !important;
    line-height: 1.6;
  }

  a {
    color: #fdcb6e !important;
    text-decoration: none;
    transition: color 0.3s ease;
    
    &:hover {
      color: #e17055 !important;
      text-decoration: underline;
    }
  }

  strong, b {
    color: #74b9ff !important;
    font-weight: 600;
  }

  em, i {
    font-style: italic;
    color: #a29bfe !important;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 1rem 0;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    overflow: hidden;
  }

  th, td {
    padding: 1rem;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    color: #f8f9fa !important;
  }

  th {
    background: rgba(253, 203, 110, 0.2);
    color: #fdcb6e !important;
    font-weight: 600;
  }

  /* Override all inline styles for better readability */
  * {
    color: #f8f9fa !important;
  }

  h1, h2, h3, h4, h5, h6,
  *[data-custom-class="heading_1"],
  *[data-custom-class="heading_2"],
  *[data-custom-class="title"] {
    color: #fdcb6e !important;
  }

  strong, b,
  *[style*="font-weight: bold"],
  *[style*="font-weight:bold"] {
    color: #74b9ff !important;
  }

  /* Specific overrides for termly classes */
  [data-custom-class="body_text"] {
    color: #f8f9fa !important;
  }

  [data-custom-class="link"] {
    color: #fdcb6e !important;
  }

  [data-custom-class="subtitle"] {
    color: #e9ecef !important;
  }

  /* Additional overrides for better visibility */
  [style*="color: rgb(89, 89, 89)"],
  [style*="color: rgb(127, 127, 127)"] {
    color: #f8f9fa !important;
  }

  /* Termly-specific class overrides */
  bdt,
  .question,
  bdt.question,
  [class*="question"],
  bdt[class*="question"] {
    color: #f8f9fa !important;
  }

  /* Override any gray colored spans or elements */
  span[style*="color: rgb(127, 127, 127)"],
  span[style*="color: rgb(89, 89, 89)"],
  div[style*="color: rgb(127, 127, 127)"],
  div[style*="color: rgb(89, 89, 89)"] {
    color: #f8f9fa !important;
  }

  /* Responsive text sizing */
  @media (max-width: 768px) {
    font-size: 0.9rem;
    line-height: 1.6;
  }

  /* Lists appearance */
  ul {
    list-style-type: square;
  }

  /* Collapse excessive blank lines coming from Termly markup */
  br {
    display: none;
  }

  /* Hide divs that only contain a <br> */
  div > br:only-child {
    display: none;
  }

  /* Remove margins on empty blocks */
  div:empty, p:empty {
    display: none;
  }
`;
